import "./utils/stringUtils";

import React from "react";
import ReactDOM from "react-dom/client";
import "./style/index.css";
import "./utils/i18n";
import App from "./App";

import { AdminCategoriesContextProvider } from "./context/AdminCategoriesContext";
import { CatalogCategoriesContextProvider } from "./context/CatalogCategoriesContext";
import { AuthContextProvider } from "./context/AuthContext";
import { CartContextProvider } from "./context/CartContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthContextProvider>
      <CartContextProvider>
        <CatalogCategoriesContextProvider>
          <AdminCategoriesContextProvider>
            <App />
          </AdminCategoriesContextProvider>
        </CatalogCategoriesContextProvider>
      </CartContextProvider>
    </AuthContextProvider>
  </React.StrictMode>
);
